import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useEffect } from 'react';

const TRUSTED_SHOPS_ELEMENT_ID = 'trustedShopsCheckout';

declare const trustbadge: { remove(): void; reInitialize(): void } | undefined;

export const useTrustcard = (salesOrder: SalesOrder | undefined, telemetry: ITelemetry): void => {
    useEffect(() => {
        try {
            const hasTrustcardScript = typeof trustbadge !== 'undefined';
            if (!salesOrder || !hasTrustcardScript) {
                return;
            }

            const elementExists = document.getElementById(TRUSTED_SHOPS_ELEMENT_ID) !== null;
            if (elementExists) {
                return;
            }

            const div = document.createElement('div');
            div.id = TRUSTED_SHOPS_ELEMENT_ID;
            div.style.display = 'none';

            const fields: { id: string; value: string | number | undefined }[] = [
                { id: 'OrderNr', value: salesOrder.Id },
                { id: 'BuyerEmail', value: salesOrder.ReceiptEmail },
                { id: 'OrderAmount', value: salesOrder.SalesPaymentDifference },
                { id: 'OrderCurrency', value: salesOrder.CurrencyCode },
                { id: 'OrderPaymentType', value: salesOrder.TenderLines?.[0]?.CardTypeId }
            ];

            fields.forEach(({ id, value }) => {
                const span = document.createElement('span');
                span.id = `tsCheckout${id}`;
                span.innerText = value !== undefined ? String(value) : '';
                div.appendChild(span);
            });

            document.body.appendChild(div);

            trustbadge?.remove();
            trustbadge?.reInitialize();
        } catch (error) {
            const message = `[useTrustcard] Failed to initialize Trustcard:\n${error instanceof Error ? error.message : String(error)}`;
            console.error(message);
            telemetry?.error(message, error);
        }
    }, [salesOrder, telemetry]);
};
